var React = require('react');

function DropArrow (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"keyboard_arrow_down-24px"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Product-Management-Certification----training-details---v2---Default","transform":"translate(-1253.000000, -4167.000000)","fill":"#FF4552","fillRule":"nonzero"},React.createElement("g",{"id":"keyboard_arrow_down-24px","transform":"translate(1253.000000, 4167.000000)"},React.createElement("polygon",{"id":"Path","points":"1.88 0.253333333 8 6.36 14.12 0.253333333 16 2.13333333 8 10.1333333 0 2.13333333"}))))]);
}

DropArrow.defaultProps = {"width":"16px","height":"11px","viewBox":"0 0 16 11","version":"1.1"};

module.exports = DropArrow;

DropArrow.default = DropArrow;
